import { useSelector, useStore } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as AppMapping from '../store/actions/app'

export const useAppSnackbar = () => {
    const store = useStore()
    const app = bindActionCreators(AppMapping, store.dispatch)
    const appStore = useSelector(state => state.app.snackbar)

    const show = (message, mode = 'info', duration = null, position={vertical: 'top', horizontal: 'right' }) => {
        app.showSnackbar(message, mode, duration, position)
    }

    const hide = () => {
        app.hideSnackbar()
    }

    return { show, hide, config: appStore }
}